import { useTranslations } from 'next-intl'

import RecentItem from 'component/page/search/dropdown-card/recent-item'
import { useRecentSearchStore } from 'store/recent-search'
import SearchLink from './search-link'

const RecentCard = () => {
  const t = useTranslations()
  const recentSearch = useRecentSearchStore(state => state.recentSearch)

  if (!recentSearch.length) {
    return (
      <div className='my-[12px] text-center text-md font-normal text-label-l2'>
        {t('search.hint')}
      </div>
    )
  }

  return (
    <>
      <div className='px-[16px] py-[12px] text-lg font-semibold'>
        {t('search.recent')}
      </div>
      {recentSearch.map(item => (
        <div key={`recent_${item.type}_${item.id}`}>
          <SearchLink item={item}>
            <RecentItem item={item} />
          </SearchLink>
        </div>
      ))}
    </>
  )
}

export default RecentCard
